export const COMMUNITY_FILE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'application/octet-stream',
  'text/plain',
  'text/csv',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/x-compressed',
  'application/json',
];

export const COMMUNITY_FILE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'JPG',
  'heic',
  'HEIC',
  'heif',
  'HEIF',
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'xls',
  'xlsx',
  'txt',
  'zip',
  'rar',
  'csv',
  'json',
];

export const PORTAL_FILE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
export const PORTAL_FILE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'gif'];

export const COMMUNITY_IMAGE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'JPG',
  'heic',
  'HEIC',
  'heif',
  'HEIF',
];

export const COMMUNITY_IOS_IMAGE_EXTENSIONS = ['heic', 'HEIC', 'heif', 'HEIF'];

export const COMMUNITY_IMAGE_REGEX = new RegExp(`.(${COMMUNITY_IMAGE_EXTENSIONS.join('|')})$`);
